import { TeamState } from "@alienheadwars/football-card-manager-model";
import { Card } from "@mui/material";
import { TeamCard, TeamCardProps } from "../../../../cards/teamCards/teamCard";
import { DIGITAL_FONTS } from "../../../../fonts/fonts";

interface TeamScoreCardComponentProps extends TeamCardProps {
    team: TeamState

}
export const TeamScoreCardComponent = (props: TeamScoreCardComponentProps) => {
    return <TeamCard {...props} additionalChildren={<ScoreCardComponent {...props} />} />
}

export const ScoreCardComponent = (props: TeamScoreCardComponentProps) => {
    return <Card sx={{
        alignContent: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        justifyItems: 'center',
        display: 'flex',
        aspectRatio: '1/1',
        height: props.dimensions.cardWidth,
        fontFamily: DIGITAL_FONTS,
        fontSize: props.dimensions.playerNameFontSize,
        margin: props.dimensions.playerNameBackgroundPadding,
    }}
    >
        {props.team.score}
    </Card>
}